<template>
    <b-container fluid class="">
        <b-row class="justify-content-between flex-center">
            <b-col cols="12" md="6">
                <h3>{{$t('dashboard.title')}}</h3>
            </b-col>
            <b-col cols="12" md="6" lg="6" xl="4">
                <b-input-group class="w-100 my-2" :prepend="$t('ticket_scan.button')">
                    <b-form-input type="text" v-model="searchText"></b-form-input>
                    <b-input-group-append>
                        <b-btn><span class="fa fa-search"></span></b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <hr/>

        <b-row>
            
        </b-row>

        <!-- <b-row class="w-100 noMargin">
            <b-col cols="12" md="4" class="eventDash p-2 text-center" v-for="event in filterItems" @click="goToEvent(event.id)" v-b-popover.hover.right="$t('hover.msg')">
                <h5> {{ event.name }} <span> {{ event.date | moment('DD.MM.YYYY') }} </span></h5>
                <b-progress :value="event.scanned/event.total * 100" variant="success" striped :animated="animate"></b-progress>

            </b-col>
        </b-row> -->

        <b-container fluid class="p-2">
            <b-row class="w-100 noMargin justify-content-center">
            <b-col cols="12" md="3" class="eventDash m-2 p-4 shadow-lg" v-for="event in filterItems"  @click="goToEvent(event.id)" v-b-popover.hover.right="$t('hover.msg')">
                <b-row class="pb-4">
                    <b-col cols="6"><h6 class="text-left"> {{ event.name }} </h6>
                    </b-col>
                    <b-col cols="6">
                        <b-badge variant="success" class="p-1 float-right">
                        <i class="fas fa-calendar-day mr-1"></i>
                        <span>
                            {{ event.date | moment('DD.MM.YYYY') }}</span>
                            </b-badge>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="9">
                        <h4  v-b-popover.hover.left="$t('sales.scanned')">{{ event.scanned }}</h4>
                        <p v-b-popover.hover.left="$t('sales.total')" style="color: grey">{{ event.total }}</p>
                    </b-col>
                    <b-col cols="3" style="color: grey">
                        <p>{{parseInt(event.scanned/event.total * 100)}}%</p>
                        </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-progress :value="event.scanned/event.total * 100" variant="success" striped :animated="animate" class="mt-2"></b-progress>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        </b-container>
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'dashboardEvents',
        data() {
            return {
                animate: true,
                events: null,
                event: {},
                eventsFields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'date',
                        label: 'Date',
                        sortable: true
                    },
                ],
                searchText: "",
            }
        },
        computed: {
            filterItems() {
                if (this.events) {
                    return this.events.filter(event => {
                        return event['name'].toLowerCase().includes(this.searchText.toLowerCase());
                    });
                } else {
                    return this.events;
                }
            },
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            getEvents(){
                this.$axios.get('eventsDash').then(response => {
                    if (response.data.success) {
                        this.events = response.data.data;
                        //console.log(this.events);
                    }else{
                         this.$toasted.global.err({
                        message : this.$t(response.data.data.msg)
                            });
                    }
                })
            },
            goToEvent(id) {
                this.$router.push('/dashboard/' + id)
            },
        },
        created() {
            let self = this;
            this.getEvents();
            this.interval = setInterval(function () {
                self.getEvents();
            }, 5000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>